<script>
import { formatPhoneNumber } from '@utils/phone-format'

export default {
  props: {
    interfaces: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      searchText: '',
      searchInput: null,
      searchedColumn: '',
      formatPhoneNumber: formatPhoneNumber,
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          key: 'id',
          scopedSlots: {
            customRender: 'customRender',
          },
          defaultSortOrder: 'ascend',
          sorter: (a, b) => a.id - b.id,
        },
        {
          title: 'Name',
          dataIndex: 'name',
          key: 'name',
          scopedSlots: {
            customRender: 'customRender',
          },
          defaultSortOrder: 'descend',
          sorter: (a, b) => a.name.localeCompare(b.name),
        },
        {
          title: 'Carrier',
          dataIndex: 'carrier_name',
          key: 'carrier_name',
          scopedSlots: {
            customRender: 'customRender',
          },
          defaultSortOrder: 'descend',
          sorter: (a, b) => a.carrier_name.localeCompare(b.carrier_name),
        },
        {
          title: 'Signal',
          dataIndex: 'signal_bar',
          key: 'signal_bar',
          scopedSlots: {
            customRender: 'customRender',
          },
          defaultSortOrder: 'descend',
          sorter: (a, b) => a.signal_bar - b.signal_bar,
        },
        {
          title: 'SIM',
          dataIndex: 'imsi',
          key: 'imsi',
          scopedSlots: {
            customRender: 'customRender',
          },
          defaultSortOrder: 'descend',
          sorter: (a, b) => a.imsi - b.imsi,
        },
      ],
    }
  },
  methods: {
    selectRow(record) {
      this.$emit('updateConflict', record)
    },
    handleSearch(selectedKeys, confirm, dataIndex) {
      confirm()
      this.searchText = selectedKeys[0]
      this.searchedColumn = dataIndex
    },
    handleReset(clearFilters) {
      clearFilters()
      this.searchText = ''
    },
    editSim(record) {
      const simId = record.pk.replace('SIM#', '')
      this.$router.push({
        name: 'sim-profile',
        params: { simId },
      })
    },
    editConnection(record) {
      const connectionId = record.pk.replace('CONNECTION#', '')
      this.$router.push({
        name: 'connection-profile',
        params: { connectionId },
      })
    },
  },
}
</script>

<template>
  <a-table :data-source="interfaces" :columns="columns">
    <div
      slot="filterDropdown"
      slot-scope="{
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
        column,
      }"
      style="padding: 8px"
    >
      <a-input
        v-ant-ref="(c) => (searchInput = c)"
        :placeholder="`Search ${column.dataIndex}`"
        :value="selectedKeys[0]"
        style="display: block; width: 188px; margin-bottom: 8px"
        @change="(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])"
        @pressEnter="
          () => handleSearch(selectedKeys, confirm, column.dataIndex)
        "
      />
      <a-button
        type="primary"
        icon="search"
        size="small"
        style="width: 90px; margin-right: 8px"
        @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
      >
        Search
      </a-button>
      <a-button
        size="small"
        style="width: 90px"
        @click="() => handleReset(clearFilters)"
      >
        Reset
      </a-button>
    </div>
    <a-icon
      slot="filterIcon"
      slot-scope="filtered"
      type="search"
      :style="{ color: filtered ? '#108ee9' : undefined }"
    />
    <template slot="customRender" slot-scope="text, record, index, column">
      <span v-if="searchText && searchedColumn === column.dataIndex">
        <template
          v-for="(fragment, i) in text
            .toString()
            .split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))"
        >
          <mark
            v-if="fragment.toLowerCase() === searchText.toLowerCase()"
            :key="i"
            class="highlight"
            >{{ fragment }}</mark
          >
          <template v-else>{{ fragment }}</template>
        </template>
      </span>
      <template v-else>
        <div v-if="column.key === 'name'">
          <a-tag :color="record.status_led">
            {{ text }}
          </a-tag>
        </div>
        <div v-else-if="column.key === 'id'">
          <div v-if="record.connection">
            <a
              href="javascript:;"
              title="Edit Connection"
              @click="editConnection(record.connection)"
              >{{ record.id }}</a
            >
          </div>
          <div v-else>
            {{ text }}
          </div>
        </div>
        <div v-else-if="column.key === 'signal_bar'" class="signal--container">
          <span v-for="j in text" :key="j" class="signal--container-bar"></span>
        </div>
        <div v-else-if="column.key === 'imsi'">
          <div v-if="record.sim">
            <span>IMSI: {{ text }}</span
            ><br />
            MTN:
            <a
              href="javascript:;"
              title="Edit SIM"
              @click="editSim(record.sim)"
              >{{ record.sim.meta.mtn }}</a
            >
          </div>
        </div>
        <div v-else>
          {{ text }}
        </div>
      </template>
    </template>
  </a-table>
</template>

<style lang="scss" scoped>
.highlight {
  padding: 0;
  background-color: rgb(255, 192, 105);
}

.signal--container {
  display: flex;
  height: 20px;
  margin: 0 auto;
  margin-bottom: -20px;

  &-bar {
    display: inline-block;
    width: 5px;
    transform: translateY(-100%);
  }
  @for $i from 1 through 5 {
    &-bar:nth-child(#{$i}) {
      height: 10% * $i;
      margin-top: 5px;
      background: rgb((255 / $i), 150 + 25 * $i, 0);
    }
  }
}
#conn--container td > div {
  text-transform: uppercase;
}
</style>
